/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ListQuery } from './listQuery.schema';

export const SearchIncidentRecords = zod.object({
  "payload": zod.lazy(() => ListQuery).optional()
});

export type SearchIncidentRecords = zod.input<typeof SearchIncidentRecords>;
export type SearchIncidentRecordsOutput = zod.output<typeof SearchIncidentRecords>;
